export const testimonials = [
  {
    id: 1,
    name: "夜宵摊常客",
    role: "追瓜三年",
    quote:
      "别家只给结论，瓜田会把时间线和来龙去脉一起摆出来，看完自己就能判断，省了好多来回猜的功夫。",
  },
  {
    id: 2,
    name: "柠檬不加冰",
    role: "综艺爱好者",
    quote:
      "最喜欢综艺内幕这个栏目，剪辑逻辑那篇看完直呼好家伙，再回去看节目完全是两种体验。",
  },
  {
    id: 3,
    name: "拿铁续命中",
    role: "通勤读物",
    quote:
      "早上地铁上刷两篇快讯刚刚好，长度合适、废话少，评论区也理性，不像别的地方全是互撕。",
  },
  {
    id: 4,
    name: "数据派老王",
    role: "行业观察读者",
    quote:
      "把吃瓜吃出方法论这个方向很对味，商务和数据那几篇讲得比我平时看的分析报告还清楚。",
  },
];